import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_INSTANCES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import createPaginatedGetAction from '@/store/helpers/createPaginatedGetAction'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowInstances = {
  namespaced: true,
  state: buildInitialState({
    workflowInstanceList: [],
    totalRecords: 0
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowInstancesWithFilters ({ dispatch, rootGetters }) {
      return dispatch('getWorkflowInstances', { ...rootGetters['workflowInstanceFilters/getSearchObject'] })
    },
    getWorkflowInstancesWithDashboardFilters ({ dispatch, rootGetters }) {
      return dispatch('getWorkflowInstances', { ...rootGetters['workflowDashboardFilters/getSearchObject'] })
    },
    getWorkflowInstancesWithFiltersPaginated ({ dispatch, rootGetters }, paginationParams = {}) {
      return dispatch('getWorkflowInstancesPaginated', {
        ...rootGetters['workflowDashboardFilters/getSearchObject'],
        ...paginationParams
      })
    },
    getWorkflowInstances ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading instances, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_INSTANCES, parameters: filters })
        .then(json => json.data)
        .then(instances => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowInstances', instances)
          return instances
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load workflow instances')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getWorkflowInstancesPaginated: createPaginatedGetAction(PATH_WORKFLOW_INSTANCES, 'setPaginatedWorkflowInstances', 'Unable to load workflow instances')
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowInstances (state, instances) {
      state.workflowInstanceList = instances
      state.totalRecords = Array.isArray(instances) ? instances.length : 0
    },
    setPaginatedWorkflowInstances (state, { result, totalRecords }) {
      state.workflowInstanceList = result
      state.totalRecords = totalRecords
    }
  }
}

export default workflowInstances
